export enum InputType {
  PASSWORD = 'password',
  EMAIL = 'email',
}
